import React, { useState } from "react";
import { observer } from "mobx-react";
import { Menu, Dropdown, Button } from "antd";
import { MoreOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import RenameModal from "./rename";
import confirm from "@app/components/confirm";

import "./style/chat-list.scoped.scss";
import { useChatAgeSort } from "./use-chat-age-sort";

const ChatList = observer(({ chats, activeChat, onRemove, onRename, onOpen }) => {
    const [renameChat, setRenameChat] = useState(null);

    const [recent, older] = useChatAgeSort(chats);

    function handleOpen(e, chat) {
        onOpen(chat._id);
    }

    function handleEdit(e, chat) {
        e.preventDefault();
        e.stopPropagation();

        setRenameChat(chat);
    }

    async function handleRemove(e, chat) {
        e.preventDefault();
        e.stopPropagation();

        let proceed = await confirm("Are you sure you want to remove this chat?");
        if (proceed) {
            onRemove(chat._id);
        }
    }

    function onCancelRename() {
        setRenameChat(null);
    }

    function handleRename(data) {
        onRename(renameChat._id, data.name);
        setRenameChat(null);
    }

    return (
        <div className="chat-list">
            <div className="list">
                {recent.length > 0 && (
                    <>
                        <div className="group-title">Recent Chats</div>
                        {recent.map((chat) => {
                            return (
                                <Chat
                                    key={chat._id}
                                    chat={chat}
                                    active={chat._id === activeChat}
                                    onOpen={handleOpen}
                                    onEdit={handleEdit}
                                    onRemove={handleRemove}
                                />
                            );
                        })}
                    </>
                )}

                {older.length > 0 && (
                    <>
                        <div className="group-title">Older Chats</div>
                        {older.map((chat) => {
                            return (
                                <Chat
                                    key={chat._id}
                                    chat={chat}
                                    active={chat._id === activeChat}
                                    onOpen={handleOpen}
                                    onEdit={handleEdit}
                                    onRemove={handleRemove}
                                />
                            );
                        })}
                    </>
                )}

                {older.length === 0 && recent.length === 0 && (
                    <>
                        <div className="no-chats">
                            No previous chats. Use the prompt field below to start chatting with
                            CAPTIS Copilot.
                        </div>
                    </>
                )}
            </div>

            {renameChat && (
                <RenameModal
                    initialValue={renameChat.name}
                    onClose={onCancelRename}
                    onSave={handleRename}
                />
            )}
        </div>
    );
});

const Chat = observer(({ chat, active, onEdit, onRemove, onOpen }) => {
    const ChatMenu = (
        <Menu>
            <Menu.Item
                onClick={({ domEvent }) => onEdit(domEvent, chat)}
                icon={<EditOutlined />}
                key="edit"
            >
                Rename
            </Menu.Item>
            <Menu.Item
                onClick={({ domEvent }) => onRemove(domEvent, chat)}
                icon={<DeleteOutlined />}
                key="remove"
            >
                Remove
            </Menu.Item>
        </Menu>
    );

    return (
        <div
            className={`chat ${active ? "active" : ""}`}
            key={chat._id}
            onClick={(e) => onOpen(e, chat)}
        >
            <span className="name">{chat.name}</span>

            <Dropdown
                overlay={ChatMenu}
                trigger="click"
                placement="bottomRight"
                onClick={(e) => e.stopPropagation()}
            >
                <Button type="icon" icon={<MoreOutlined />} />
            </Dropdown>
        </div>
    );
});

export default ChatList;
